import { Component } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { IAddress } from '@services/cleanfill-core/address-service/address.model';
import { CountryStoreService } from '@services/cleanfill-core/country-service/country-store.service';

@Component({
  selector: 'company-information',
  templateUrl: './company-information.component.html',
  styleUrls: ['./company-information.component.scss']
})
export class CompanyInformationComponent {
  get formGroup() {
    return this.formRef ? this.formRef.control : null;
  }
  get address() {
    return this.formGroup.get('address') as FormGroup;
  }
  constructor(public formRef: ControlContainer, public countryStoreService: CountryStoreService) {}

  outputAddressDetailsEvent(addressDetails: IAddress) {
    this.address.patchValue({
      line1: addressDetails.line1 + addressDetails.line2,
      provinceUniqueId: addressDetails.provinceId,
      city: addressDetails.city,
      postalCode: addressDetails.postalCode
    });
  }
}
